import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './initElement'
import './filter'
import 'element-ui/lib/theme-chalk/index.css';
import './utils/rem'
import store from './store'
import echarts from 'echarts'
import infiniteScroll from 'vue-infinite-scroll'
Vue.use(infiniteScroll)
Vue.config.productionTip = false
//echart
Vue.prototype.$echarts = echarts
new Vue({
  render: h => h(App),
  router,
  store,
}).$mount('#app')